var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-container" }, [
    _c("div", { staticClass: "dashboard-text" }, [_vm._v(_vm._s(_vm.name))]),
    _vm._v(" "),
    _c("div", { staticClass: "dashboard-tips" }, [
      _vm._v("请使用左边的导航栏目，使用相应功能")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }